import {
  AppCard,
  PageContainer,
} from "@equinor/e-procurement-portal-and-ts-portal-front-end-components";
import { CircularProgress, Container, Typography } from "@mui/material";
import { createFileRoute } from "@tanstack/react-router";
import { useSnackbar } from "notistack";
import type React from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useShowBrand } from "../../../../../__generated__/orval/endpoints/brands/brands";
import { ForbiddenError } from "../../../../../errors/ForbiddenError";
import { DetailsCard } from "./-internal_components/DetailsCard";
import { HistoryCard } from "./-internal_components/HistoryCard";

const ShowExclusiveBrand: React.FC = () => {
  const { id } = Route.useParams();
  const brandId = Number.parseInt(id, 10);

  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();

  const {
    data: brand,
    error: brandError,
    isError: isBrandError,
    isLoading: isBrandLoading,
    refetch: refetchBrand,
  } = useShowBrand(brandId, {
    query: {
      enabled: Number.isFinite(brandId),
    },
  });

  useEffect(() => {
    if (isBrandError) {
      console.error(brandError);
      enqueueSnackbar(t("exclusiveBrand.fetchError"), {
        variant: "error",
      });
    }
  }, [brandError, enqueueSnackbar, isBrandError, t]);

  if (isBrandLoading) {
    return (
      <Container
        sx={{
          alignItems: "center",
          display: "flex",
          height: "100vh",
          justifyContent: "center",
        }}
      >
        <CircularProgress />
      </Container>
    );
  }

  if (!brand) {
    return (
      <PageContainer showBackButton title={t("common.exclusiveBrand")}>
        <AppCard>
          <Typography>{t("common.noBrandsFound")}</Typography>
        </AppCard>
      </PageContainer>
    );
  }

  return (
    <PageContainer
      showBackButton
      subtitle={brand.name}
      title={t("common.exclusiveBrand")}
    >
      <DetailsCard brand={brand} brandId={brandId} onRefresh={refetchBrand} />

      <HistoryCard brandId={brandId} />
    </PageContainer>
  );
};

export const Route = createFileRoute(
  "/_private/vsupplierregistration/exclusive_brands/$id/",
)({
  beforeLoad({ context }) {
    if (context.auth.user?.roles_names.includes("Brand Exclusive - Update")) {
      return;
    }

    throw new ForbiddenError();
  },
  component: ShowExclusiveBrand,
});
